<template>
  <div>
    <!-- Filtering Settings -->
    <el-row type="flex" justify="space-between" class="p-2">
      <el-col></el-col>
      <el-col :span="12" :lg="4" v-if="searchOn.length">
        <el-form :inline="true" @submit.native.prevent>
          <el-input maxlength="240px" clearable
            placeholder="（search keyword）" v-model="search.keyword"
            @change="onSearchKeywordChange">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form>
      </el-col>
    </el-row>

    <!-- Table Body -->
    <el-table v-loading="isLoading" element-loading-background="rgba(0, 0, 0, 0.6)"
      :data="rows" v-bind="$attrs" v-on="listeners"
      header-cell-class-name="">

      <slot name="columns">

        <el-table-column v-for="col in schema" :key="col.key"
          :sortable="col.sortable? 'custom': false"
          :prop="col.key" :label="col.label"
          :width="col.width" :align="col.align || 'left'" 
          :header-align="col.align || 'left'">

          <!-- Default cell format -->
          <template slot-scope="{row}">
            <slot :name="col.key" :row="row">
              {{ row[col.key] }}
            </slot>
          </template>

        </el-table-column>

      </slot>

    </el-table>

    <!-- Footer / Pagination -->
    <el-row type="flex" justify="space-between" align="middle">
      <el-col :span="12" :md="8">
        <el-pagination
          :page-size="paging.perPage" :total="paging.total"
          @current-change="onPageRequest" layout="prev, pager, next">
        </el-pagination>
      </el-col>

      <el-col :span="12" :md="8">
        每頁顯示筆數：
        <el-select v-model="paging.perPage" size="mini" @change="onPerPageChange">
          <el-option v-for="pp in perPageOptions"
            :key="pp" :label="pp" :value="pp">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="12" :md="8">
        總筆數：<b>{{ paging.total }}</b>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Pagination
} from 'element-ui';

import axios from 'axios';

export default {
  name: 'SSRTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination
  },
  props: {
    data: {
      type: Array,
      default: () => { return []; }
    },
    dataUrl: String,
    dataKey: String,
    schema: Array,
    perPageOptions: {
      type: Array,
      default: () => { return [10, 20, 30]; }
    },
    disablePagination: {
      type: Boolean,
      default: false
    },

    searchOn: {
      type: Array,
      default: () => { return []; }
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      let limit = this.paging.perPage;
      let startIndex = this.paging.perPage * (this.paging.current - 1);

      // Non-SSR, just load the rows.
      if (!this.dataUrl) {
        if (this.data.length) {
          this.fillTable(this.data.slice(startIndex, startIndex + limit));
        }
        else {
          this.rows = [ ];
        }
        return;
      }

      // SSR mode. Begin request for data to show.
      this.loading = true;
      let queryStringStarter = this.dataUrl.indexOf('?') > 0? '&': '?';
      let getUrl = `${this.dataUrl}${queryStringStarter}limit=${limit}&startIndex=${startIndex}`;
      if (this.sort.by)
        getUrl += `&sort=${this.sort.by}:${this.sort.ordering}`;
      if (this.searchOn.length && this.search.keyword.length)
        getUrl += `&search=${this.searchOn.join(',')}:${encodeURIComponent(this.search.keyword)}`;
      
      axios.get(getUrl)
      .then(response => {
        this.fillTable(response.data);

        //FIXME: Forward the response body to parent component.
        this.$emit('server-response', response.data);
      })
      .catch(err => {
        console.error(`[SSRTable] Error loading ${getUrl}`, err);
      })
      .finally(() => {
        this.isLoading = false;
      })
    },

    fillTable(data) {
      if (Array.isArray(data))
        this.rows = data;
      else if (this.dataKey)
        this.rows = data[this.dataKey];
      else
        throw new Error(`No valid list data given.`);
      
      // Update paging.
      this.paging.total = data['total'];
      if (this.paging.total === undefined)
        this.paging.total = this.rows.length;
    },

    onPageRequest(page) {
      // console.log(`[SSRTable] onPageRequest`, page);
      this.paging.current = page;
    },
    onPerPageChange(pp) {
      // console.log(`[SSRTable] onPerPageChange`, pp);
    },
    onSortRequest(args) {
      console.log(`[SSRTable] onSortRequest`, args);
      this.sort.by = args.prop;
      this.sort.ordering = {
        'ascending': 'asc', 'descending': 'desc'
      }[ args.order ] || 'asc';
      this.loadData();
    },
    onSearchKeywordChange(keyword) {
      this.paging.current = 1;
      this.loadData();
    }
  },

  data() {
    return {
      isLoading: false,

      rows: [],

      paging: {
        current: 1,
        perPage: this.perPageOptions[0],
        total: 0
      },
      sort: {
        by: null,
        ordering: 'asc'
      },
      search: {
        // by: null,
        keyword: ''
      }
      
    }
  },

  computed: {
    paginationLength() {
      return Math.ceil(this.paging.total / this.paging.perPage);
    },

    listeners() {
      return {
        ...this.$listeners,
        ['sort-change']: this.onSortRequest
      }
    }
  },

  watch: {
    'paging.perPage': 'loadData',
    'paging.current': 'loadData',
    'dataUrl': function() {
      this.paging.current = 1;
      this.loadData();
    }
  }
}
</script>

<style scoped>
/* So that text and carets in <th> align each other */
th div.cell {
  -webkit-box-align: center !important;
  align-items: center !important;
  min-height: 34px;
  line-height: 34px;
}
</style>